<div class="numberplate-scan" [ngClass]="styleClass">
  <sc-flex vertical [centered]="true" stretchContent fitHeight>
    <div class="identifier">{{title}}</div>
    <sc-content-spacer [double]="true"></sc-content-spacer>
    <ng-container *ngIf="scanResult == null">
      <div class="numberplate">&nbsp;</div>
    </ng-container>
    <ng-container *ngIf="scanResult != null">
      <div class="numberplate">{{scanResult?.numberplate}}</div>
    </ng-container>
  </sc-flex>
</div>
